import React, { useEffect, useState } from 'react';
import './style.scss';
import ListWithDetails from 'components/Common/ListWithDetails';
import GenericBadge from 'components/Utils/GenericBadge';
import DefaultButton from 'components/Utils/NewDefaultButton';
import CorporateBatches from 'components/Misc/CorporateClients/CorporateBatches';
import Icon from 'components/Utils/NewIcon';
import CorporateDetails from 'components/Misc/CorporateClients/CorporateDetails';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { useAppSelector } from 'careand-redux/store';
import { api } from 'careand-redux/api/ApiThunks';
import ConfirmationButton from '../../Utils/NewDefaultButton/ConfirmationButton';

const CorporateClients = (props) => {
  const dispatch = useAppDispatch();
  const corporations = useAppSelector((state) => state.corporations.corporations);
  const [loading, setLoading] = useState(false);
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(api.Corporations.getCorporations(), { errorTitle: 'Corporations' }).finally(() => {
      setLoading(false);
    });
    dispatch(api.Payments.getAllPaymentPlans());
    dispatch(api.Corporations.getUnpaidBatches());
  }, [dispatch]);

  async function addNewCorporation() {
    setAdding(true);
    let response = await dispatch(
      api.Corporations.addCorporation({ corporation: { name: 'New Corporation' } }),
      {
        errorTitle: 'Corporation',
      },
    );
    setAdding(false);
  }

  return (
    <div className="corporate-clients box full-width full-height">
      <ListWithDetails
        items={corporations}
        loading={loading}
        addButton={
          <ConfirmationButton
            name="Add Corporate Client"
            loading={adding}
            onClick={addNewCorporation}
            confirmation={{
              message: 'Are you sure you want to create a new corporate client?',
            }}
            style={{ display: 'block', margin: 'auto' }}
          />
        }
        renderBadge={(corporation) => (
          <CorporationBadge key={corporation.id} corporation={corporation} />
        )}
        renderDetails={(corporation) => (
          <CorporationProfile key={corporation.id} corporation={corporation} />
        )}
      />
    </div>
  );
};

const CorporationBadge = ({ corporation }) => {
  const unpaid = useAppSelector((state) => state.corporations.unpaidCount);
  const count = unpaid[corporation.id] ?? 0;

  return <GenericBadge title={corporation.name} count={count} />;
};

const ICONS = ['building', 'layer-group'];

const CorporationProfile = ({ corporation = {} }) => {
  const [activeIcon, setActiveIcon] = useState(ICONS[0]);

  return (
    <div className="corporation-details box details-panel flex !w-full">
      <ul className="icon-list side-bar-vertical shadow-300">
        {ICONS.map((icon, i) => (
          <li key={i} onClick={() => setActiveIcon(icon)} className="clickable">
            <Icon
              src={icon}
              height="20px"
              tooltipPlace="right"
              className={activeIcon === icon ? 'blue' : 'dark-grey'}
            />
          </li>
        ))}
      </ul>
      {activeIcon === ICONS[0] && <CorporateDetails corporation={corporation} />}

      {activeIcon === ICONS[1] && <CorporateBatches corporation={corporation} />}
    </div>
  );
};

export default CorporateClients;
